import React from "react";
import PropTypes from "prop-types";

const EmptyContainer = ({ children }) => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="text-black font-black text-2xl">{children}</div>
    </div>
  );
};

EmptyContainer.propTypes = {
  children: PropTypes.node,
};

export default EmptyContainer;
